/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Taxonomy_Alternatives_Card_MetaInputs */

const en_directory_taxonomy_alternatives_card_meta = /** @type {(inputs: Directory_Taxonomy_Alternatives_Card_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare alternatives`)
};

const zh_directory_taxonomy_alternatives_card_meta = /** @type {(inputs: Directory_Taxonomy_Alternatives_Card_MetaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`对比替代方案`)
};

/**
* | output |
* | --- |
* | "Compare alternatives" |
*
* @param {Directory_Taxonomy_Alternatives_Card_MetaInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_taxonomy_alternatives_card_meta = /** @type {((inputs?: Directory_Taxonomy_Alternatives_Card_MetaInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Taxonomy_Alternatives_Card_MetaInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_taxonomy_alternatives_card_meta(inputs)
	return zh_directory_taxonomy_alternatives_card_meta(inputs)
});
export { directory_taxonomy_alternatives_card_meta as "directory.taxonomy.alternatives.card_meta" }